import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const ProgressApi = createApi({
  reducerPath: "progressApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getProgressCountsByTimeApi: builder.query({
      query: (range: string) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchProgressStreakByTime(dateRange: "${range}") {
              error
              data {
                progressType
                currentStartDate
                currentEndDate
                previousStartDate
                previousEndDate
                timeZone
                currentRangeData {
                  started
                  completed
                  assigned
                }
                previousRangeData {
                  started
                  completed
                  assigned
                }
                growthRatePercentage {
                  started
                  completed
                  assigned
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Progress" }
    })
  })
});

export const { useGetProgressCountsByTimeApiQuery } = ProgressApi;
